import { CatalogBuilder } from "../../../commonGroupModuleStructure/catalogBuilder";
import { deleteFeature, getFeaturesPaging, getFeaturesTree } from "./apiCall";
import { FeaturesKeys } from "./entity";

export const Features = (props: any) => {

  const columns = [
    {
      field: "Name",
      headerName: "Name",
      flex: 1,
      minWidth: 130,
      headerAlign: "left",
    },
    {
      field: "DisplayName",
      headerName: "Display Name",
      flex: 1,
      minWidth: 130,
      headerAlign: "left",
    },
    {
      field: "ModuleName",
      headerName: "Module Name",
      flex: 1,
      minWidth: 130,
      headerAlign: "left",
    },
    {
      field: "MenuName",
      headerName: "Menu Name",
      flex: 1,
      minWidth: 130,
      headerAlign: "left",
    },
  ];

  return (
    <CatalogBuilder
      headerLabel="Feature"
      headerButtonLabel="Add Features"

      getPagingData={getFeaturesPaging}
      pagingAPIKey={FeaturesKeys.paging}

      onDelete={deleteFeature}
      deletePagingAPIKey={FeaturesKeys.delete}

      getTreeData={getFeaturesTree}
      treeApiKey={FeaturesKeys.tree}
      treeViewLabel="FeatureAccess"

      onModeClickPath="/feature/details/"
    />
  );
};
